var render = function render(){var _vm=this,_c=_vm._self._c;return _c('autocomplete',{staticStyle:{"width":"100%"},attrs:{"source":_vm.companyList,"placeholder":"Select Company...","value":_vm.value},on:{"selected":_vm.handleSelect},model:{value:(_vm.selectedCompany),callback:function ($$v) {_vm.selectedCompany=$$v},expression:"selectedCompany"}})
}
var staticRenderFns = []

export { render, staticRenderFns }